import React, { useState, useRef } from 'react';
import { ChevronDownIcon, PhoneIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  return <div className={`border-b border-slate-200 last:border-0 transition-colors duration-300 ${isOpen ? 'border-l-2 border-l-[#E8913A] pl-6 -ml-6 bg-[#E8913A]/5' : ''}`} data-id="element-56">
      <button className="w-full py-6 px-4 md:px-6 flex justify-between items-center text-left focus:outline-none" onClick={onClick} aria-expanded={isOpen} data-id="element-57">
        <span className={`text-lg md:text-xl pr-4 transition-colors ${isOpen ? 'font-bold text-[#1B2A4A]' : 'font-semibold text-[#1B2A4A]/90'}`} data-id="element-58">
          {question}
        </span>
        <ChevronDownIcon className={`w-5 h-5 text-[#E8913A] transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-59" />
      </button>
      <div className="overflow-hidden transition-all duration-300 ease-in-out" style={{
      height: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px'
    }} data-id="element-60">
        <div ref={contentRef} className="px-4 md:px-6 pb-6" data-id="element-61">
          <p className="text-slate-600 leading-relaxed text-lg" data-id="element-62">{answer}</p>
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-28 px-6 md:px-12 lg:px-16" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        <div className="mb-16" data-id="element-65">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B2A4A] mb-6 tracking-tight" data-id="element-66">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl" data-id="element-67">
            Have questions? We have answers. Here's what homeowners usually ask
            us.
          </p>
        </div>

        <div className="pl-6" data-id="element-68">
          <FAQItem question="How do you determine my offer?" answer="Our process is straightforward. We look at the location of the property, what repairs are needed, the current condition, and values of comparable houses sold in the area recently. We take all these pieces of information to come up with a fair price that works for us and works for you." isOpen={openIndex === 0} onClick={() => setOpenIndex(openIndex === 0 ? null : 0)} data-id="element-69" />
          <FAQItem question="Are there any fees or commissions?" answer="No. This is what makes us stand out from the traditional method of selling your house. There are NO fees or commissions when you sell your house to us. We'll make you an offer, and if it's a fit, we'll buy your house (and we'll often pay for the closing costs too!)." isOpen={openIndex === 1} onClick={() => setOpenIndex(openIndex === 1 ? null : 1)} data-id="element-70" />
          <FAQItem question="How fast can I close?" answer="We can typically close in as little as 7 days. However, we work on your timeline. If you need more time to pack, move, or figure out your next steps, we can schedule the closing for a date that works best for you." isOpen={openIndex === 2} onClick={() => setOpenIndex(openIndex === 2 ? null : 2)} data-id="element-71" />
          <FAQItem question="Do I need to clean or repair anything?" answer="Absolutely not. We buy houses strictly as-is. You don't need to repair anything, paint, or even sweep the floors. You can even leave behind unwanted furniture or trash—we will handle all the cleanup after we purchase the home." isOpen={openIndex === 3} onClick={() => setOpenIndex(openIndex === 3 ? null : 3)} data-id="element-72" />
          <FAQItem question="Is there any obligation when I submit my info?" answer="There is absolutely zero obligation. Once you tell us a bit about your property, we'll take a look at things, maybe set up a call with you to find out a bit more, and make you an all-cash offer that's fair for you and fair for us. From there, it's 100% your decision on whether or not you'd like to sell your house to us." isOpen={openIndex === 4} onClick={() => setOpenIndex(openIndex === 4 ? null : 4)} data-id="element-73" />
        </div>

        {/* Still have questions CTA */}
        <div className="mt-16 pt-8 border-t border-slate-100" data-id="element-74">
          <p className="text-slate-600 mb-3 text-lg" data-id="element-75">Still have questions?</p>
          <a href="tel:8883417570" className="inline-flex items-center text-[#1B2A4A] font-semibold hover:text-[#E8913A] transition-colors text-xl" data-id="element-76">
            <PhoneIcon className="w-5 h-5 mr-3" data-id="element-77" />
            Call us at (888) 341-7570
          </a>
        </div>
      </div>
    </section>;
}